<template lang="pug">
div.modal-content-configuration

    form.modal-body

        div.form--row.form-subtitle.l-flex-row Connect to server
            .highlight.connect-server {{ connectionLabel }}

        div.form-configuration
            div.l-flex-row.has-gutter_medium
                //- config label (required)
                div.form-subsection.w-180
                    div.form-label__required
                        label Configuration name
                    input.form-input(
                        id="config-name"
                        name="label"
                        v-model="dataFormConfig.label"
                        v-validate="'max:200|required'"
                        placeholder="Job label"
                        type="text")
                    span.form-validate-error {{ errors.first('label') }}

                //- config type (required)
                div.form-subsection.w-180(v-if="formAction==='create'")
                    div.form-label
                        label Choose your file type
                    select.form-select.big(
                        id="config-task"
                        name="task"
                        v-model="dataFormConfig.task")
                        option(
                            v-for="item in optionTypes",
                            :key="item.value",
                            :label="item.label",
                            :value="item.value"
                        ) {{ item.label }}


            div.l-flex-row.has-gutter_medium
                //- config file path (required)
                div.form-subsection.w-180
                    div.form-label__required
                        label File path
                    input.form-input(
                        id="config-file-path"
                        name="file-path"
                        v-model="dataFormConfig.remote_path"
                        v-validate="'max:255|required'"
                        placeholder="Path"
                        type="text")
                    span.form-validate-error {{ errors.first('file-path') }}
                //- config file pattern (required)
                div.form-subsection.w-180
                    div.form-label__required
                        label File pattern
                    input.form-input(
                        id="config-file-pattern"
                        name="file-pattern"
                        v-model="dataFormConfig.file_pattern"
                        v-validate="'max:255|required'"
                        placeholder="File name with date YYYYMMDD"
                        type="text")
                    span.form-validate-error {{ errors.first('file-pattern') }}

            div.form-subsection-email
                //- config email
                div.form-subsection.w-100
                    div.form-label.l-flex-row--between
                        label Email(s) to notify
                        div.counter {{ defaultCcEmailValues.length }}/10

                    EmailCcField(
                        parent="DemFormConfiguration"
                        placeholder="user@weborama.com"
                        :defaultValues="defaultCcEmailValues"
                        @formCcListUpdate="updateFormCcList"
                        :maxItems="10"
                    )

            div.l-flex-row.has-gutter_medium
                //- config file compression
                div.form-subsection-row.simple.form-input-extra.w-180
                    input(
                        id="config-file-compression"
                        name="file-compression"
                        v-model="isFileCompressed"
                        type="checkbox")
                    label(for="config-file-compression") File compression
                //- config remove file
                div.form-subsection-row.simple.form-input-extra.w-180
                    input(
                        id="config-remove-file"
                        name="remove-file"
                        v-model="removeRemoteFiles"
                        type="checkbox")
                    label(for="config-remove-file") Delete remote file

            div.l-flex-row.has-gutter_medium
                //- config Separator (required)
                div.form-subsection.w-180
                    div.form-label
                        label Separator
                    select.form-select.big(
                        id="config-delimitor"
                        name="delimitor"
                        v-model="dataFormConfig.delimitor")
                        option(
                            v-for="item in optionSeparator",
                            :key="item.value",
                            :label="item.label",
                            :value="item.value"
                        ) {{ item.label }}
                div.form-subsection.w-180

                //- config encrypted identifier
                div.form-subsection.w-180(v-if="configType !== 'CRM'")
                    input(
                        id="config-encrypted-id"
                        name="encrypted-identifier"
                        v-model="isWeboIdCrypted"
                        type="checkbox")
                    label(for="config-encrypted-id") Encrypted identifiers

            div.l-flex-row.has-gutter_medium(v-if="configType !== 'proxy'")
                //- Website CRM ID (required)
                div.form-subsection.w-180
                    div.form-label__required
                        label Namespace pattern
                    select.form-select.big(
                        id="config-namespace"
                        name="namespace"
                        v-model="dataFormConfig.out_idcrm_pattern")
                        option(
                            v-for="(item, index) in patternList",
                            :key="index",
                            :value="item"
                        ) {{ item }}

                //- config file crm id (required)
                div.form-subsection.w-180
                    div.form-label__required
                        label Identifier label in file
                    input.form-input(
                        id="config-identifier-label-file"
                        name="identifier-label-file"
                        v-model="dataFormConfig.idcrm_pattern"
                        v-validate="'max:255|required'"
                        :placeholder="placeholderIDCrm"
                        type="text")
                    span.form-validate-error {{ errors.first('identifier-label-file') }}


    //- Footer
    footer.modal-footer
        div.footer-content.l-flex-row--between
            button.btn.btn--medium.btn--round(@click.prevent="cancelConfig()") Cancel
            button.btn.btn--medium.btn--round.btn-rev(:class="{'ui-disabled': disabledButton}" @click="saveConfig()") {{formAction}} configuration

</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { cloneDeep, includes, isEmpty, isNil, toString, size, toNumber, isEqual } from 'lodash'

import { getTokenUserEmail } from '@/utils/helpers'
// Form Validation

import Vue from 'vue'

import { DEM_CONFIGURATION_FORM_DATA, DEM_CONFIGURATION_FORM_SEPARATORS, DEM_CONFIGURATION_FORM_TYPES } from '@/utils/constants'
import EmailCcField from '@/components/common/EmailCcField'

export default {
    name: 'FormConfiguration',

    props: {
        dataForm: { type: Object, required: true },
        closeModal: { type: Function, required: true }
    },
    components: {
        EmailCcField
    },

    mounted() {
        if (this.formAction === 'create') {
            this.inputEmail = getTokenUserEmail(Vue.prototype.$keycloak)
            if (this.dataFormConfig) this.dataFormConfig.finish_alert_emails = [getTokenUserEmail(Vue.prototype.$keycloak)]
        }
        if (!this.dataFormConfig.out_idcrm_pattern) this.dataFormConfig.out_idcrm_pattern = this.getNamespacesPatterns()[0]
    },

    data() {
        return {
            dataFormConfig: cloneDeep(this.dataForm),
            optionSeparator: cloneDeep(DEM_CONFIGURATION_FORM_SEPARATORS),
            optionTypes: cloneDeep(DEM_CONFIGURATION_FORM_TYPES),
            inputEmail: '',
            isFileCompressed: toNumber(this.dataForm.is_file_compressed),
            isWeboIdCrypted: toNumber(this.dataForm.is_weboid_crypted),
            removeRemoteFiles: toNumber(this.dataForm.remove_remote_files),
            processing: false
        }
    },

    computed: {
        ...mapState('ui/dataEntry', {
            connectionId: state => state.connectionId,
            formAction: state => state.formAction
            // formIsValid: state => state.formIsValid.configuration
        }),
        ...mapState('account', {
            accountId: state => state.accountId
        }),
        ...mapGetters('data/dataEntry', ['getConnectionFromConnectionId']),
        ...mapGetters('account', ['getNamespacesPatterns']),
        connection() {
            return this.getConnectionFromConnectionId({ id: this.connectionId })
        },

        placeholderIDCrm() {
            return this.configType === 'CRM' ? 'ID CRM in the file' : 'Identifier'
        },

        connectionLabel() {
            return !isNil(this.connection) ? this.connection.label : ''
        },
        configType() {
            return includes(this.dataFormConfig.task, 'crm') ? 'offlineDatalayer' : includes(this.dataFormConfig.task, 'wam_proxy') ? 'proxy' : 'CRM'
        },
        commonDisablingInfo() {
            return (
                size(this.errors.items) !== 0 ||
                isEmpty(this.dataFormConfig.label) ||
                isEmpty(this.dataFormConfig.remote_path) ||
                isEmpty(this.dataFormConfig.file_pattern)
            )
        },
        disabledButton() {
            if (this.configType === 'CRM' || this.configType === 'offlineDatalayer') {
                return this.commonDisablingInfo || isEmpty(this.dataFormConfig.out_idcrm_pattern) || isEmpty(this.dataFormConfig.idcrm_pattern)
            }
            return this.commonDisablingInfo || this.processing
        },

        patternList() {
            return this.getNamespacesPatterns()
        },
        defaultCcEmailValues() {
            if (isEqual(this.dataFormConfig.finish_alert_emails, ['']) || isEqual(this.dataFormConfig.finish_alert_emails[0], '')) return []
            else if (Array.isArray(this.dataFormConfig.finish_alert_emails)) return this.dataFormConfig.finish_alert_emails
            return this.dataFormConfig.finish_alert_emails.split(',')
        },

        counterEmail() {
            const { finish_alert_emails } = this.dataFormConfig
            return finish_alert_emails?.[0] !== '' && finish_alert_emails?.length > 0
        }
    },

    methods: {
        ...mapActions('data/dataEntry', ['createConfiguration', 'updateItem']),
        // Call to mutations
        ...mapMutations('ui/dataEntry', ['setFormConfiguration']),

        cancelConfig() {
            this.processing = false
            this.closeModal()
        },
        updateFormCcList(ccList) {
            this.dataFormConfig.finish_alert_emails = ccList
        },
        saveConfig() {
            if (this.processing) return // Prevent multiple creation
            this.processing = true
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    const configForm = {
                        ...this.dataFormConfig,
                        account_id: toString(this.accountId),
                        connector_cred_id: this.connectionId,
                        is_proxy_mode: this.configType === 'proxy' ? 1 : 0,
                        is_weboid_crypted: this.isWeboIdCrypted ? JSON.stringify(1) : JSON.stringify(0),
                        remove_remote_files: this.removeRemoteFiles ? JSON.stringify(1) : JSON.stringify(0),
                        is_file_compressed: this.isFileCompressed ? JSON.stringify(1) : JSON.stringify(0)
                    }

                    if (this.formAction === 'create') {
                        this.createConfiguration({ configForm })
                            .then(() => {
                                this.setFormConfiguration({ formConfiguration: cloneDeep(DEM_CONFIGURATION_FORM_DATA) })
                            })
                            .catch(() => {})
                    } else {
                        this.updateItem({
                            item: configForm,
                            dataType: 'configuration'
                        })
                            .then(() => {
                                this.closeModal()
                            })
                            .catch(() => {})
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.connect-server {
    margin-left: 4px;
}
</style>
